export default "__VITE_ASSET__79cf02d5__"